import { AuthHttp } from '@/helpers/http-helper'
import router from '@/router/index'

const state = {
  token: {}
}

const getters = {
  getToken: state => state.token
}

const mutations = {
  setToken (state, token) {
    state.token = token
  },
  removeToken (state) {
    state.token = {}
  }
}

const actions = {
  login ({ commit, rootState }, user) {
    user.posValue = rootState.config.config.deviceId
    return AuthHttp.post('api/login', user).then(authResponse => {
      var employeeResponse = {}
      employeeResponse.data = authResponse.data.posConfig

      var response = {}
      response.data = authResponse.data.authorization
      response.data.employee = {
        name: employeeResponse.data.employeeName,
        id: employeeResponse.data.employeeId,
        foodLimit: employeeResponse.data.foodLimit,
        canCashOut: employeeResponse.data.canCashOut,
        freeTablePermission: employeeResponse.data.freeTablePermission,
        tablePlanId: employeeResponse.data.employeeTablePlanId,
        duePaymentPermission: employeeResponse.data.duePaymentPermission,
        deleteOrderPermission: employeeResponse.data.deleteOrderPermission,
        reservationsPermission: employeeResponse.data.reservationsPermission,
        liveTickerAllOrders: employeeResponse.data.liveTickerAllOrders
      }

      response.data.userPermissions = authResponse.data.userPermissions

      response.data.role = {
        name: employeeResponse.data.roleName
      }

      response.data.config = {
        businessNumber: employeeResponse.data.businessNumber,
        fiscalNumber: employeeResponse.data.fiscalNumber,
        address: employeeResponse.data.address,
        bankNr: employeeResponse.data.bankNr,
        bankId: employeeResponse.data.bankId,
        bank: { name: employeeResponse.data.bankName },
        telephone: employeeResponse.data.telephone,
        contactPerson: employeeResponse.data.contactPerson,
        defaultVatId: employeeResponse.data.defaultVatId,
        fiscalConfirmation: employeeResponse.data.fiscalConfirmation,
        delivery: employeeResponse.data.delivery,
        freeTable: employeeResponse.data.freeTable,
        kitchenPrinter: employeeResponse.data.kitchenPrinter,
        bankCard: employeeResponse.data.bankCard,
        directOrder: employeeResponse.data.directOrder,
        adminClockin: employeeResponse.data.adminClockin,
        printOrderAfterPayment: employeeResponse.data.printOrderAfterPayment,
        splitOrder: employeeResponse.data.splitOrder,
        logoutAfterOrdering: employeeResponse.data.logoutAfterOrdering,
        backToTablesAfterOrdering: employeeResponse.data.backToTablesAfterOrdering,
        waiterAccess: employeeResponse.data.waiterAccess,
        alwaysPrintOrder: employeeResponse.data.alwaysPrintOrder,
        orderTotalNonFical: employeeResponse.data.orderTotalNonFical,
        managerHandouts: employeeResponse.data.managerHandouts,
        hasMobilePos: employeeResponse.data.hasMobilePos,
        deliveryDefault: employeeResponse.data.deliveryDefault,
        countryId: employeeResponse.data.countryId,
        currency: employeeResponse.data.currency,
        freePayment: employeeResponse.data.freePayment,
        countryCode: employeeResponse.data.countryCode,
        name: employeeResponse.data.configName,
        notRestaurant: employeeResponse.data.notRestaurant,
        allowNegativeStock: employeeResponse.data.allowNegativeStock,
        clientCard: employeeResponse.data.clientCard,
        activeVouchers: employeeResponse.data.activeVouchers,
        closeSalesDayAutomatically: employeeResponse.data.closeSalesDayAutomatically,
        closedTime: employeeResponse.data.closedTime,
        approveDamages: employeeResponse.data.approveDamages,
        adminConfirmAppClose: employeeResponse.data.adminConfirmAppClose,
        languageId: employeeResponse.data.languageId,
        languageCode: employeeResponse.data.languageCode,
        codeAndMakers: employeeResponse.data.codeAndMakers,
        damages: employeeResponse.data.damages,
        liveTicker: employeeResponse.data.liveTicker,
        liveTickerMyOrders: employeeResponse.data.liveTickerMyOrders,
        includeBankAmountHandouts: employeeResponse.data.includeBankAmountHandouts,
        disableOrderComments: employeeResponse.data.disableOrderComments,
        logoutAfterPayment: employeeResponse.data.logoutAfterPayment,
        backToTablesAfterPayment: employeeResponse.data.backToTablesAfterPayment,
        freePaymentConfirmation: employeeResponse.data.freePaymentConfirmation,
        vat: employeeResponse.data.vat,
        hasDisplays: employeeResponse.data.hasDisplays,
        onlyFiscal: employeeResponse.data.onlyFiscal,
        isService: employeeResponse.data.isService,
        serviceClient: employeeResponse.data.serviceClient,
        directOnlyFiscal: employeeResponse.data.directOnlyFiscal,
        searchClientCards: employeeResponse.data.searchClientCards,
        genericIdentifier: employeeResponse.data.genericIdentifier,
        genericSpotId: employeeResponse.data.genericSpotId,
        baseUrl: employeeResponse.data.baseUrl,
        macId: employeeResponse.data.macId,
        macKey: employeeResponse.data.macKey,
        showAllTableTotals: employeeResponse.data.showAllTableTotals,
        orderTotalNonFiscalOptional: employeeResponse.data.orderTotalNonFiscalOptional,
        liveTickerNoActions: employeeResponse.data.liveTickerNoActions,
        waiterSelfHandouts: employeeResponse.data.waiterSelfHandouts,
        courseSpliters: employeeResponse.data.courseSpliters,
        priceList: employeeResponse.data.priceList,
        freePaymentWithFiscal: employeeResponse.data.freePaymentWithFiscal,
        printerNameTicket: employeeResponse.data.printerNameTicket
      }

      response.data.pin = user.pin
      response.data.deviceId = authResponse.data.id

      commit('setToken', response.data)
      return response.data
    }).catch(error => {
      return Promise.reject(error)
    })
  },
  logout ({ commit }) {
    commit('removeToken')
    router.push({name: 'LoginView'})
  }
}

export default {
  namespaced: true,
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js